module.exports = __webpack_public_path__ + "static/media/diana_tn.4eaf6e5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/diana_tn.jpg
// module id = 676
// module chunks = 0